import { React, useState, useEffect } from "react";

const PopUpSicboResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    let sicboMarkets = [];
    let sicboWinners = [];

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    if (marketType == 27) {
        sicboMarkets = [
            "Odds",
            "Even",
            "Any Tripple",
            "Small(4-10)",
            "Big(11-17)",
            "No Tripple",

            "1+1+1",
            "2+2+2",
            "3+3+3",
            "4+4+4",
            "5+5+5",
            "6+6+6",

            "No Winner",

            "Three",
            "Four",
            "Five",
            "Six",
            "Seven",
            "Eight",
            "Nine",
            "Ten",
            "Eleven",
            "Twelve",
            "Thirteen",
            "Fourteen",
            "Fifteen",
            "Sixteen",
            "Seventeen",
            "Eighteen",
        ];

        sicboWinners = resultData?.resultTxt
            ? resultData.resultTxt.split(",").map((x) => x.trim())
            : [];
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="sicbo" style={{ display: marketType == 27 ? "" : "none" }} >
                        <div className="left-content">
                            <div className="card">

                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>

                                <div className="card-body">

                                    <div style={{ textAlign: "center", marginBottom: "25px" }}>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                gap: "20px",
                                                marginBottom: "20px"
                                            }}
                                        >
                                            {[resultData.c1, resultData.c2, resultData.c3].map((dice, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        width: "80px",
                                                        height: "80px",
                                                        border: "2px solid #555",
                                                        borderRadius: "16px",
                                                        background: "#fff",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        fontSize: "46px",
                                                        fontWeight: "bold",
                                                        color: "red",
                                                        boxShadow: "0 3px 8px rgba(0,0,0,.35)"
                                                    }}
                                                >
                                                    {dice}
                                                </div>
                                            ))}
                                        </div>

                                    </div>

                                    {sicboMarkets.map((market, index) => {
                                        const winner = sicboWinners.includes(market);

                                        return (
                                            <div className="sicbo-result-row" key={index}>
                                                <div className="sicbo-market">
                                                    {market}
                                                </div>

                                                <div
                                                    className="sicbo-status"
                                                >
                                                    {winner ? "WINNER" : "LOSER"}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpSicboResults;

